<template>
    <ArvaModal
      name="DataRanchForceImportModal"
      :title="modalTitle"
      :wide="isWidePopup"
      width="900"
      @close-modal="handleCloseModalWithoutAction"
    >
      <div class="float-left">
        <file-upload
          id="ranchforce-upload-file"
          v-if="state === 'file-upload-modal'"
          ref="uploadFile"
          v-model="files"
          :accept="eligibleFiles"
          :drop="true"
          :multiple="true"
          @input="updatedFileUploaded"
          @input-filter="fileUploadedInputFilter"
        />
      </div>
      <!-- Initial View -->
      <div v-if="state === 'initial'" class="row modal-pad">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <div class="info-text">
                You can import files by either connecting an online account (John
                Deere, Climate, etc.), or uploading files directly from your
                computer
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-around my-4">
            <div class="selection-box" @click="openJD">
              <div class="logo logo-john-deere mx-auto" />
              <div class="selection-text">Connect to John Deere</div>
            </div>
            <div
              id="select-data-type"
              class="selection-box"
              @click="state = 'select-data-type'"
            >
              <div>
                <i class="fa fa-laptop" />
              </div>
              <div class="selection-text">Import from your computer</div>
            </div>
          </div>
          <div class="d-flex justify-content-around my-4">
            <div class="selection-box" @click="state = 'climate'">
              <div class="logo logo-climate mx-auto" />
              <div class="selection-text">Connect to Climate</div>
            </div>
            <div class="selection-box" @click="connectAgriWebb">
              <div class="logo logo-agriwebb mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 21" width="60" height="60">
                  <path
                    fill="#808080"
                    fill-rule="evenodd"
                    d="m33.02 18.38-5.16-9.2L22.7 0H12.4l5.15 9.18H7.24l-5.16 9.2H0V21h14.31v-2.62h-1.93l5.16-9.2 5.15 9.2h-1.93V21h14.31v-2.62h-2.05Z"
                    clip-rule="evenodd"
                  />
                  <path
                    fill="#808080"
                    fill-rule="evenodd"
                    d="M7.23 9.18h10.3l-5.15 9.2-5.15-9.2Z"
                    clip-rule="evenodd"
                  />
                  <path
                    fill="#808080"
                    fill-rule="evenodd"
                    d="m12.38 0 5.16 9.18h10.32L22.7 0H12.4Z"
                    clip-rule="evenodd"
                  />
                  <path
                    fill="#808080"
                    fill-rule="evenodd"
                    d="m33.02 18.38-5.16-9.2H17.54l5.15 9.2h-1.93V21h14.31v-2.62h-2.05Z"
                    clip-rule="evenodd"
                  />
                  <path
                    fill="#808080"
                    fill-rule="evenodd"
                    d="m12.38 18.38-5.15-9.2-5.15 9.2H0V21h14.31v-2.62h-1.93Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div class="selection-text">Import from AgriWebb</div>
            </div>
            </div>
          
        </div>
      </div>
  
      <!-- Select Data Type View -->
      <div v-if="state === 'select-data-type'" class="row modal-pad">
        <div class="col-12">
          <SelectOrg :orgNodes="orgNodes" @change-org-id="changeOrgId" />
  
          <div class="info-text">
            Select the data type you're about to import. Please ensure that you
            only upload files of the selected type.
          </div>
  
          <div class="form-group">
            <label for="datatype">Data Type</label>
            <v-select-old
              :options="datasetTypes"
              :reduce="type => type.key"
              label="name"
              v-model="datasetType"
            />

            <div class="mt-3" v-if="datasetType == 'import-enrichedag-ranching-data'">
              <label for="pasture">Select Pasture</label>
              <v-select-old
                v-model="pastureId"
                :options="pastures"
                :reduce="pasture => pasture.id"
                label="name"
                clearable
              >
                <template #option="{ id, name, boundary_image }">
                  <div class="pasture-option">
                    <img
                      :src="boundary_image"
                      :alt="name"
                      class="pasture-image"
                    />
                    <span class="pasture-id">{{ id }}</span>
                    <span class="pasture-name">{{ name }}</span>
                  </div>
                </template>

                <template #selected-option="{ id, name, boundary_image }">
                  <div class="pasture-option">
                    <img
                      :src="boundary_image"
                      :alt="name"
                      class="pasture-image"
                    />
                    <span class="pasture-id">{{ id }}</span>
                    <span class="pasture-name">{{ name }}</span>
                  </div>
                </template>
              </v-select-old>
            </div>
  
            <button
              class="btn btn-primary"
              :class="{ disabled: !datasetType }"
              :disabled="isNextDisabled"
              @click="handleNextState()"
            >
              Next
            </button>
          </div>
        </div>
      </div>
  
      <!-- Client/Farm/Field Confirmations View -->
      <div v-if="state === 'confirmation-client-spec'" class="row modal-pad confirmation-modal pb-5">
        <div class="col-8 offset-2 text-center">
          <label class="text-left w-100 mb-0">Confirmation Type<span class="asterisk-super">*</span></label>
          <v-select
            class="mt-0 pt-0"
            role="button"
            v-model="confirmationType"
            placeholder="Type"
            :items="confirmationTypeChoicesRANCH"
            item-text="name"
            item-value="value"
            clearable
          />
  
          <div class="confirmation-client-spec-modal">
            <label class="text-left w-100 mb-0">Choose Year<span class="asterisk-super">*</span></label>
            <v-select
              class="mt-0 pt-0"
              role="button"
              v-model="confirmationYear"
              placeholder="Year"
              :items="getYearOptions(2019)"
              clearable
            />
  
            <div>
              <label class="text-left w-100 mb-0">Choose Client<span class="asterisk-super">*</span></label>
              <v-select
                class="mt-0 pt-0"
                role="button"
                v-model="confirmationClient"
                placeholder="Client"
                item-text="name"
                item-value="id"
                :items="clients"
                clearable
              />
            </div>
  
            <div>
              <label class="text-left w-100 mb-0">Choose Ranches</label>
              <v-select
                class="mt-0 pt-0"
                role="button"
                v-model="confirmationFarms"
                placeholder="Ranch"
                item-text="name"
                item-value="id"
                :items="farms"
                clearable
                multiple
                chips
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 2">
                    <span>{{ item.name }}</span>
                  </v-chip>
  
                  <span v-if="index === 2" class="text-grey text-caption align-self-center">
                    (+{{ confirmationFarms.length - 2 }} other{{ confirmationFarms.length == 3 ? '' : 's' }})
                  </span>
                </template>
              </v-select>
            </div>
  
            <label class="text-left w-100 mb-0">Choose Animal</label>
            <v-select
              class="mt-0 pt-0"
              role="button"
              v-model="confirmationCrops"
              placeholder="Animal"
              item-text="name"
              item-value="id"
              :items="crops"
              clearable
              multiple
              chips
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2">
                  <span>{{ item.name }}</span>
                </v-chip>
  
                <span v-if="index === 2" class="text-grey text-caption align-self-center">
                  (+{{ confirmationCrops.length - 2 }} other{{ confirmationCrops.length == 3 ? '' : 's' }})
                </span>
              </template>
            </v-select>
  
            <div v-if="loadingFieldResponse" class="spinner-border spinner-border-sm spinner" role="status" />
            <div v-else >
              <label class="text-left w-100 mb-0">Choose Pastures/Lots</label>
              <v-select
                class="mt-0 pt-0"
                role="button"
                v-model="confirmationFields"
                placeholder="Pastures/Lots"
                item-text="name"
                item-value="id"
                :items="fields"
                clearable
                multiple
                chips
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 2">
                    <span>{{ item.name }}</span>
                  </v-chip>
    
                  <span v-if="index === 2" class="text-grey text-caption align-self-center">
                    (+{{ confirmationFields.length - 2 }} other{{ confirmationFields.length == 3 ? '' : 's' }})
                  </span>
                </template>
              </v-select>
            </div>
  
            <button
              :class="`btn btn-primary confirmation-btn ${!confirmationValidation ? 'disabled' : ''}`"
              :disabled="!confirmationValidation"
              @click="handleNextState()"
            >
              Next
            </button>
          </div>
        </div>
      </div>
  
      <!-- Upload View -->
      <div v-if="state === 'upload'" class="row modal-pad">
        <div class="col-12 text-center">
          <div
            class="upload-box"
            :class="{ dropping: dropActive }"
            @click="handleUploadClick"
          >
            <i class="fa fa-upload" :class="{ green: dropActive }" />
            <h2>Drop files here to upload</h2>
            <div v-if="datasetType == 'boundary' || datasetType == 'boundary-ranch'">
              <i class="fa fa-file" />.zip .shp .dbf .prj .shx .kml .kmz .geojson
            </div>
            <div v-else-if="datasetType == 'practice-confirmations'">
              <i class="fa fa-file" />
              .zip, .csv, .jpg, .jpeg, .png, .pdf
            </div>
            <div v-else-if="datasetType == 'sustainability-quantification-report'">
              <i class="fa fa-file" />.csv
            </div>
            <div v-else-if="datasetType == 'ranching-feeding' && isRanchForce">
              <i class="fa fa-file" />.csv
            </div>
            <div v-else-if="datasetType == 'enrichedag-boundary-ranch' && isRanchForce">
              <i class="fa fa-file" />.zip .shp .dbf .prj .shx .csv
              <div>These files may include information for multiple fields</div>
            </div>
            <div v-else-if="datasetType == 'import-enrichedag-ranching-data' && isRanchForce">
              <i class="fa fa-file" />.csv
            </div>
            <div v-else><i class="fa fa-file" />.zip .shp .dbf .prj .shx</div>
            <div>These files may include information for multiple fields</div>
          </div>
        </div>
      </div>
  
      <!-- Climate Choice View -->
      <div v-if="state === 'climate'" class="row modal-pad">
        <div class="col-12">
          <div class="d-flex justify-content-around my-4">
            <div class="selection-box" @click="openLeaf">
              <div class="selection-text">Import from Your Account</div>
            </div>
            <div class="selection-box" @click="state = 'climate-choice'">
              <div class="selection-text">Import from Client Account</div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Climate Client View -->
      <div v-if="state === 'climate-choice'" class="row modal-pad">
        <div class="col-12">
          <div class="text-center">
            <span class="climate-text">Select which client to import from:</span>
          </div>
          <div class="d-flex justify-content-around my-2">
            <div class="select-container">
              <v-select-old
                :options="orgNodes"
                :reduce="node => node.id"
                label="name"
                v-model="orgNodeForClimate"
              />
            </div>
          </div>
          <div class="text-center pt-4">
            <span class="climate-text">Enter grower email:</span>
          </div>
          <div class="d-flex justify-content-around my-2">
            <div class="select-container">
              <v-text-field
                dense
                outlined
                label="Grower Email"
                v-model="growerEmail"
                type="text"
              ></v-text-field>
            </div>
          </div>
          <div class="d-flex justify-content-around">
            <v-btn
              @click="handleSendGrowerEmail"
              :disabled="!orgNodeForClimate || !growerEmail"
              >Import</v-btn
            >
          </div>
        </div>
      </div>
  
      <!-- Climate API Result View -->
      <div
        v-if="state === 'client-result'"
        class="row modal-pad complete-pad text-center"
      >
        <div class="col-12 complete">
          <div>
            <i class="fa fa-check-circle complete-check" />
          </div>
          <h2>
            An email regarding your client's climate import has been sent
            successfully!
          </h2>
          <button class="btn btn-primary" @click="handleCloseModal('')">Close</button>
        </div>
      </div>

      <!-- Select Data Type View -->
      <div v-if="state === 'pasture-data-handle'" class="row pasture-name-modal">
        <div class="col-12">
          <div class="name-text">
            Enter the pasture name:
          </div>
  
          <v-text-field
            dense
            outlined
            label="Pasture Name"
            v-model="pastureName"
            type="text"
          ></v-text-field>
          <div class="d-flex justify-end">
            <button
              class="btn btn-primary"
              :class="{ disabled: !datasetType }"
              :disabled="isNextDisabled"
              @click="handleNextState()"
            >
              Next
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="state === 'file-upload-selection-modal'"
        class="dual-file-upload-modal"
      >
        <!-- Import Buttons -->
        <div class="upload-section">
          <div class="upload-column">
            <v-btn class="import-btn" @click="handleForageFileUpload">
              Import<br />
              Forage Allocation<br />
              CSV Files
            </v-btn>

            <div class="file-list">
              <div v-for="file in forageFiles" :key="file">
                {{ file.name }}
              </div>
            </div>
          </div>

          <div class="upload-column">
            <v-btn class="import-btn" @click="handleHerdFileUpload">
              Import<br />
              Herd Records<br />
              CSV Files
            </v-btn>

            <div class="file-list">
              <div v-for="file in herdFiles" :key="file">
                {{ file.name }}
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="footer-section">
          <button
            class="btn btn-primary"
            :disabled="isNextDisabled"
            @click="handleNextState"
          >
            Next
          </button>
        </div>
      </div>

      <!-- Upload View -->
      <div v-if="state === 'file-upload-modal'" class="row modal-pad">
        <div class="col-12 text-center">
          <div
            class="upload-box"
            :class="{ dropping: dropActive }"
            @click="handleImportFileUploadClick"
          >
            <i class="fa fa-upload" :class="{ green: dropActive }" />
            <h2>Drop files here to upload</h2>
            <div>
              <i class="fa fa-file" />.csv
            </div>
            <div>These files may include information for multiple fields child ----</div>
          </div>
        </div>
      </div>

      <!-- Animal Details And Species Modal -->
      <div
        v-if="state === 'animal-details-and-species'"
        class="animal-details-modal"
      >
        <div class="animal-details-content">
          <div class="animal-details-title">
            Match each herd file with its Species and Animal Type
          </div>

          <div class="animal-header">
            <div>File Name</div>
            <div>Species</div>
            <div>Animal Type</div>
          </div>

          <div
            v-for="(item, index) in animalDetailsPayload"
            :key="index"
            class="animal-row"
          >
            <div
              class="animal-file-name"
              :title="item.file.name"
            >
              {{ item.file.name }}
            </div>

            <v-select-old
              v-model="item.species"
              :options="speciesChoices"
              :reduce="option => option.value"
              label="display_name"
            />

            <v-select-old
              v-model="item.animals"
              :options="animalDetailChoices"
              :reduce="option => option.value"
              label="display_name"
            />
          </div>

          <div class="animal-footer">
            <button
              class="btn btn-secondary"
              @click="state = 'file-upload-selection-modal'"
            >
              Back
            </button>

            <button
              class="btn btn-primary"
              :disabled="!animalDetailsValid"
              @click="handleAnimalSpeciesNext"
            >
              Next
            </button>
          </div>
        </div>
      </div>

      <!-- Final Files Preview -->
      <div
        v-if="state === 'final-files-preview'"
        class="final-files-preview"
      >
        <div class="preview-title">
          Final Files to Import
        </div>

        <div class="preview-content">
          <!-- Forage Files -->
          <div v-if="forageFiles.length" class="preview-section">
            <div class="section-title">
              Forage Allocation Files
            </div>

            <div class="forage-list">
              <div
                v-for="(file, index) in forageFiles"
                :key="`forage-${index}`"
                class="forage-row"
              >
                {{ file.name }}
              </div>
            </div>
          </div>

          <div v-if="animalDetailsPayload.length && forageFiles.length" class="vertical-divider"></div>

          <!-- Herd Files -->
          <div v-if="animalDetailsPayload.length" class="preview-section">
            <div class="section-title">
              Herd Files
            </div>

            <div class="preview-header">
              <div>File Name</div>
              <div>Species</div>
              <div>Animal Type</div>
            </div>

            <div
              v-for="(item, index) in animalDetailsPayload"
              :key="`herd-${index}`"
              class="preview-row"
            >
              <div
                class="preview-file"
                :title="item.file.name"
              >
                {{ item.file.name }}
              </div>

              <div>
                {{ getSpeciesLabel(item.species) }}
              </div>

              <div>
                {{ getAnimalLabel(item.animals) }}
              </div>
            </div>
          </div>
        </div>

        <div class="preview-footer">
          <button
            class="btn btn-secondary"
            @click="goBackToModal"
          >
            Back
          </button>

          <button
            class="btn btn-primary"
            @click="handleFinalImport"
          >
            Done
          </button>
        </div>
      </div>
    
      <!-- Uploading Progress View -->
      <div v-if="state === 'uploading'" class="row modal-pad file-upload-pad">
        <div class="col-12">
          <h5 class="upload-title">
            <i class="fa fa-cloud-upload" />Upload Progress
          </h5>
          <small class="form-text text-muted">
            Please don't close your browser window, or your upload will be
            interrupted.
          </small>
  
          <div class="progress" style="height: 20px;">
            <div
              class="progress-bar bg-success"
              role="progressbar"
              :style="uploadWidth"
              :aria-valuenow="uploadPercentage"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ uploadPercentage }}%
            </div>
          </div>
        </div>
      </div>
  
      <!-- Complete View -->
      <div
        v-if="state === 'complete'"
        class="row modal-pad complete-pad text-center"
      >
        <div class="col-12 complete">
          <div>
            <i class="fa fa-check-circle complete-check" />
          </div>
          <h2>Upload Complete!</h2>
          <button class="btn btn-primary" @click="handleCloseModal('')">Close</button>
        </div>
      </div>
    </ArvaModal>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex"

import ArvaModal from "./ArvaModal"
import { Filter, Uploads, Defaults } from "@/store/modules"
import JohnDeereAPI from "@/api/JohnDeereAPI"
import LeafAPI from "@/api/LeafAPI"
import ClimateAPI from "@/api/ClimateAPI"
import SelectOrg from "@/components/uploads/SelectOrg"
import { CONFIRMATION_TYPE_CHOICES, CONFIRMATION_TYPE_CHOICES_RANCH } from "@/constants/defaults";
import { IS_RANCHFORCE } from "@/constants";
import { getYearsToNow } from "@/utility";
import { getRelevantFields } from "@/api/EvidencingAPI";
import PasturesAPI from "@/api/PasturesAPI"
import { mapMutations } from "vuex"

export default {
  name: "DataRanchForceImportModal",
  props: {
    dropActive: { type: Boolean },
    isUploading: { type: Boolean },
    datasetTypes: { type: Array },
    orgNodes: { type: Array },
    initialDatasetType: { type: String },
    initialState: { type: String }
  },
  components: { ArvaModal, SelectOrg },
  data() {
    return {
      selection: null,
      johnDeereURL: null,
      leafURL: null,
      state: "initial",
      datasetType: null,
      pastures: [],
      pastureId: null,
      orgNodeForClimate: null,
      growerEmail: null,
      confirmationType: '',
      confirmationClient: '',
      confirmationYear: '',
      confirmationFarms: [],
      confirmationFields: [],
      confirmationCrops: [],
      loadingFieldResponse: false,
      isRanchForce: IS_RANCHFORCE,
      pastureName: "",
      eligibleFiles: ".csv",
      uploadType: "",
      files: [],
      forageFiles: [],
      herdFiles: [],
      uploadFile: "",
      totalFiles: [],
      animalDetailsPayload: []
    }
  },

  computed: {
    ...mapState({
      organization: state => state.Organization.organization,
      uploadPercentage: state => state.Uploads.uploadPercentage,
      // aggriwebData: state => state.Uploads.aggriwebData,
    }),

    ...mapGetters({
      crops: Filter.Getters.getCrops,
      farms: Filter.Getters.getFarms,
      fields: Filter.Getters.getFields,
      clients: Filter.Getters.getClients,
      activeFields: Filter.Getters.getSelectedFields,
      practiceChoices: Defaults.Getters.getPracticeChoices,
    }),

    speciesChoices() {
      return this.practiceChoices["pasture_livestock_species"]
    },

    animalDetailChoices() {
      return this.practiceChoices["pasture_livestock_animal_details"]
    },

    animalDetailsValid() {
      return this.animalDetailsPayload.every(
        item => item.species && item.animals
      )
    },

    isWidePopup() {
      console.log("state ==============", this.state === "animal-details-and-species")
      return this.state === "animal-details-and-species" ? true : false
    },

    isNextDisabled() {
      // if this specific type requires pastureId
      if (this.datasetType == 'import-enrichedag-ranching-data') {
        return !this.pastureId
      }
      // if datasetType is not selected at all
      if (!this.datasetType) return true

      return false
    },

    confirmationTypeChoices() {
      return CONFIRMATION_TYPE_CHOICES
    },

    confirmationTypeChoicesRANCH() {
      return CONFIRMATION_TYPE_CHOICES_RANCH
    },

    confirmationValidation() {
      return this.confirmationType
        && this.confirmationYear
        && this.confirmationClient
    },

    modalTitle() {
      let title = "Import Files"
      const datasetType = this.datasetTypes.find(
        item => item.key === this.datasetType
      )
      const additional = datasetType ? datasetType.name : ""

      return additional ? `${title} - ${additional}` : title
    },

    uploadWidth() {
      return `width: ${this.uploadPercentage}%;`
    }
  },

  methods: {
    ...mapActions({
      createDataset: "Dataset/createDataset",
      listDatasets: "Dataset/listDatasets",
      // fetchAggriwebData: Uploads.Actions.fetchAgriWebData,
    }),

    ...mapMutations({
      setPastureId: Uploads.Mutations.setPastureId
    }),

    async getPastures() {
      const response = await PasturesAPI.list();
      this.pastures = response.data;
      // console.log('pastures list:', this.pastures, response);
    },

    getYearOptions(beginningYear) {
      return [new Date().getFullYear()+1 , ...getYearsToNow({ beginningYear }).sort((a, b) => b-a)];
    },

    handleCloseModal(type = "") {
      console.log("type ----", type)
      this.$emit("close-modal", { type })
    },

    handleCloseModalWithoutAction() {
      console.log("MODAL CLOSE EVENT")
      this.$emit("close-action-modal")
    },

    handleNextState() {
      let newState = 'upload';
      if (this.datasetType == 'practice-confirmations') {
        this.$emit("change-confirmation-client-specs", {
          type: this.confirmationType,
          year: this.confirmationYear,
          farms: this.confirmationFarms,
          fields: this.confirmationFields,
          crops: this.confirmationCrops,
          client: this.confirmationClient
        });

        if (this.state != 'confirmation-client-spec') {
          newState = 'confirmation-client-spec'
        }
      }

      if (this.state === 'select-data-type') {
        if (this.datasetType === 'enrichedag-boundary-ranch') {
          newState = 'pasture-data-handle'
        } else if (this.datasetType === 'import-enrichedag-ranching-data') {
          newState = 'file-upload-selection-modal'
        }
      }

      if (this.state === 'file-upload-selection-modal') {
        if (this.herdFiles.length) {
          const existingFiles = new Set(this.animalDetailsPayload.map(item => item.file.name))

          const newPayload = this.herdFiles
            .filter(file => !existingFiles.has(file.name))
            .map(file => ({
              file,
              species: "",
              animals: ""
            }))


          this.animalDetailsPayload.push(...newPayload)

          newState = "animal-details-and-species"
        } 
        
        if (this.forageFiles.length && !this.herdFiles.length) {
          newState = "final-files-preview"
        }
        
        if (!this.forageFiles.length && this.herdFiles.length) {
          newState = "animal-details-and-species"
        }
      }

      this.state = newState;
    },

    handleForageFileUpload(type) {
      console.log("File upload type ------------", type)
      this.uploadType = 'forage';
      this.state = "file-upload-modal"
    },

    handleHerdFileUpload(type) {
      console.log("File upload type ------------", type)
      this.uploadType = 'herd';
      this.state = "file-upload-modal"
    },

    openJD() {
      if (this.johnDeereURL) {
        window.open(this.johnDeereURL)
        this.handleCloseModal("")
      }
    },

    openLeaf() {
      if (this.leafURL) {
        window.open(this.leafURL)
        this.handleCloseModal("")
      }
    },

    handleSendGrowerEmail() {
      const payload = {
        org_node_id: this.orgNodeForClimate,
        email: this.growerEmail,
      }
      ClimateAPI.postClimateOrgTransfer(payload)
        .then(response => {
          console.log(response)
          this.state = "client-result"
        })
        .catch(error => {
          console.log(error)
        })
    },

    changeOrgId(org_id) {
      this.$emit("change-org-id", org_id)
    },

    handleUploadClick() {
      this.$emit("open-upload", this.pastureName)
    },
    connectAgriWebb() {
      // this.fetchAggriwebData();
      this.handleCloseModal('agriwebb');
    },

    handleImportFileUploadClick() {
      const el = document.getElementById('ranchforce-upload-file')
      const input = el.querySelector('input[type="file"]')
      if (input) input.click()
    },

    fileUploadedInputFilter(newFile, oldFile, prevent) {
      console.log("filter fired", newFile);

      if (this.datasetType == 'import-enrichedag-ranching-data') {
        if (!/\.(csv?)$/i.test(newFile.name)) return prevent()
      }
    },

    updatedFileUploaded(files) {
      console.log("Uploaded file ----------", files)
      // this.isUploading = true

      if (this.uploadType === "forage") {
        this.forageFiles.push(...files)
      } else if (this.uploadType === "herd") {
        this.herdFiles.push(...files)
      }

      this.files = [];
      this.uploadType = "";
      this.state = "file-upload-selection-modal"
      // this.isUploading = false;
    },

    handleAnimalSpeciesNext() {
      this.state = "final-files-preview";
    },

    getSpeciesLabel(value) {
      const option = this.speciesChoices?.find(
        item =>
          item.value === value ||
          item.id === value ||
          item === value
      );

      return option?.name || option?.label || value;
    },

    getAnimalLabel(value) {
      const option = this.animalDetailChoices?.find(
        item =>
          item.value === value ||
          item.id === value ||
          item === value
      );

      return option?.name || option?.label || value;
    },

    goBackToModal() {
      if (this.state === "final-files-preview" && !this.herdFiles.length) {
        this.state = "file-upload-selection-modal"
      } else if (this.state === "final-files-preview" && this.herdFiles.length) {
        this.state = "animal-details-and-species"
      }
    },

    handleFinalImport() {
      const payload = {
        herdFiles: this.animalDetailsPayload,
        forageFiles: this.forageFiles
      }

      this.$emit("close-import-enricheded-modal", payload)
    }
  },

  watch: {
    datasetType() {
      this.$emit("change-dataset-type", this.datasetType)
    },

    isUploading() {
      if (this.isUploading) this.state = "uploading"
    },

    uploadPercentage() {
      if (this.uploadPercentage === 100) this.state = "complete"
    },

    pastureId(val) {
      if (val) {
        this.setPastureId(val)
      }
    },

    // isUploadFailed() {
    //   if (this.isUploadFailed) {
    //     this.state = "failed"
    //   }
    // }
  },

  async mounted() {
    if (this.initialDatasetType) {
      this.datasetType = this.initialDatasetType;

      if (this.initialState) {
        this.state = this.initialState
      }
      else {
        this.state = 'upload';
      }
    }

    this.getPastures();

    const { data: jdUrl } = await JohnDeereAPI.fetchJohnDeereUrls()
    this.johnDeereURL = jdUrl.sso

    const { data: leaf_url } = await LeafAPI.fetchLeafUrl(this.organization.id)
    this.leafURL = leaf_url.leaf_url.url
  },
}
</script>

<style scoped>
.modal-pad {
  padding-bottom: 35px;
}

.info-text {
  text-align: center;
  max-width: 430px;
  margin: 20px auto;
  color: #777;
}

.name-text {
  text-align: left;
  font-size: 18px;
  color: black;
  max-width: 430px;
  margin-bottom: 10px;
  color: #777;
}

.selection-box {
  padding: 20px;
  border: 1pt solid #e5e5e5;
  min-width: 200px;
  text-align: center;
  cursor: pointer;
}

.selection-box:hover {
  background: #f8f8f8;
  border: 1pt solid #d5d5d5;
}

.selection-box i {
  font-size: 60px;
}

.select-container {
  width: 320px;
}

.selection-text {
  font-size: 13px;
  font-weight: 500;
  color: #666;
}

.form-group {
  margin: 20px auto 90px auto;
  padding: 0px 100px;
}

.form-group > button {
  margin-top: 20px;
  margin-right: 0px;
  float: right;
}

.upload-box {
  width: 450px;
  background: #f0f0f0;
  border: 1pt dotted black;
  margin: 20px auto;
  padding: 30px;
  cursor: pointer;
}

.upload-box:hover {
  background: #eaeaea;
}

.dropping {
  background: rgba(89, 255, 140, 0.35);
}

.upload-box .fa-upload {
  font-size: 30px;
}

.upload-box .green {
  color: green;
}

.upload-box h2 {
  font-size: 20px;
  margin-top: 10px;
  font-weight: 500;
}

.upload-box .fa-file {
  margin-right: 5px;
}

.file-upload-pad {
  padding: 40px;
  text-align: center;
}

.upload-title {
  font-size: 20px;
  font-weight: 500;
}

.upload-title i {
  font-size: 20px;
  margin-right: 5px;
}

.text-muted {
  margin-bottom: 10px;
}

.complete-pad {
  margin-top: 40px;
}

.complete h2 {
  margin-top: 10px;
  margin-bottom: 30px;
}

.complete i {
  font-size: 55px;
  color: green;
}

.logo-john-deere {
  width: 60px;
  height: 60px;
  background-image: url("/assets/images/logos/john-deere-logo.png");
  background-size: contain;
  filter: grayscale(100%);
  margin-left: auto;
  margin-right: auto;
}

.logo-climate {
  width: 60px;
  height: 60px;
  background-image: url("/assets/images/logos/climate-logo.jpg");
  background-size: contain;
  filter: grayscale(100%);
  margin-left: auto;
  margin-right: auto;
}

.climate-text {
  font-weight: 400;
  font-size: 18px;
}

.confirmation-client-spec-modal {
  min-height: 535.5px;
  position: relative;
} 

.confirmation-client-spec-modal label {
  font-size: 13px;
  line-height: 32px;
}

.confirmation-client-spec-modal /deep/ .confirmation-number input {
  text-transform: uppercase;
}

.confirmation-client-spec-modal /deep/ .confirmation-number .v-input__append-inner {
  margin-top: 8px;
}

.confirmation-client-spec-modal /deep/ .v-input .v-input__slot {
  min-height: 41px;
}

.disabled-label {
  opacity: 0.5;
}

.confirmation-modal {
  min-height: 550px;
}

.confirmation-btn {
  position: absolute;
  bottom: 0;
  right: 0;
}

.confirmation-client-farm-wrapper {
  display: flex;
  justify-content: space-between;
}

.confirmation-client-farm-wrapper > div {
  width: 48%;
}

.asterisk-super {
  vertical-align: super;
}

.pasture-name-modal {
  padding: 0 20px;
}

.pasture-option {
  display: flex;
  align-items: center;
}

.pasture-image {
  width: 28px;
  height: 28px;
  object-fit: cover;
  border-radius: 4px;
}

.pasture-id {
  width: 70px; /* adjust as needed */
  margin-left: 24px;
  flex-shrink: 0;
}

.pasture-name {
  margin-left: 12px;
}

.dual-file-upload-modal {
  padding: 20px;
}

.upload-section {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 20px;
}

.upload-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 180px;
}

.import-btn {
  width: 140px !important;
  height: 90px !important;
  text-transform: none !important;
  background-color: #e8e7e7 !important;
  line-height: 1.4;
  font-size: 13px;
  box-shadow: 1px 1px 1px grey;
}

.file-list {
  margin-top: 15px;
  width: 100%;
  font-size: 13px;
  text-align: left;
}

.file-list div {
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.footer-section {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
}

/* Modal Content */
.modal-content {
  /* align-items: center; */
  background: white;
  padding: 30px 40px;
  border-radius: 16px;
  width: 500px;
  height: 200px;
  max-width: 90%;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.close-icon {
  justify-content: end;
}

.animal-details-modal {
  padding: 20px 25px;
}

.animal-details-content {
  width: 100%;
}

.animal-details-title {
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 25px;
  color: #555;
}

.animal-header {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: 16px;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 10px;
  padding: 0 8px;
}

.animal-row {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: 16px;
  align-items: center;
  margin-bottom: 14px;
}

.animal-file-name {
  font-size: 13px;
  padding: 10px 12px;
  background: #f7f7f7;
  border: 1px solid #ddd;
  border-radius: 4px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.animal-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

.final-files-preview {
  padding: 24px;
  min-height: 500px;
  display: flex;
  flex-direction: column;
}

.preview-title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 24px;
}

.preview-content {
  flex: 1;
  display: flex;
  gap: 24px;
  min-height: 300px;
}

.preview-section {
  flex: 1;
  overflow: hidden;
}

.vertical-divider {
  width: 1px;
  background: #d9d9d9;
}

.section-title {
  text-align: center;
  font-weight: 600;
  margin-bottom: 16px;
  color: #555;
}

.forage-list {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  overflow-y: auto;
  max-height: 320px;
}

.forage-row {
  padding: 10px 12px;
  border-bottom: 1px solid #f1f1f1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.forage-row:last-child {
  border-bottom: none;
}

.preview-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 12px;
  font-weight: 600;
  padding: 10px 12px;
  border-bottom: 2px solid #ddd;
}

.preview-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid #f1f1f1;
  align-items: center;
}

.preview-file {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.preview-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e5e5e5;
}
</style>
